import type { Immutable } from 'immer';
import { useStore } from '../../store/reducers';
import type { ManagedTracker } from '../../store/trackers/trackers_reducers';

export function useTrackers(): Immutable<Array<ManagedTracker>> {
  return Array.from(useStore((s) => s.trackers.items).values());
}
